/**
 * RecentItems component
 * Shows recently accessed items in sidebar
 */

import { Clock, FileText, FolderKanban, CheckSquare } from 'lucide-react';

import { useTranslation } from '@/lib/i18n/hooks/use-translation';

import { useSidebarStore } from '../store/sidebar-store';
import './RecentItems.scss';

const MOCK_RECENT_ITEMS = [
  { id: '1', type: 'project', name: 'Project Alpha', icon: FolderKanban },
  { id: '2', type: 'task', name: 'Design Review', icon: CheckSquare },
  { id: '3', type: 'form', name: 'Q4 Contract', icon: FileText },
];

export function RecentItems() {
  const { t } = useTranslation('common');
  const isExpanded = useSidebarStore((state) => state.isExpanded);

  if (!isExpanded) {
    return null;
  }

  return (
    <div className="recent-items">
      <div className="recent-items-header">
        <Clock size={14} strokeWidth={2} />
        <span className="recent-items-title">{t('nav.recent')}</span>
      </div>
      <div className="recent-items-list">
        {MOCK_RECENT_ITEMS.map((item) => {
          const Icon = item.icon;
          return (
            <button key={item.id} className="recent-item" type="button">
              <div className="recent-item-icon-wrapper">
                <Icon className="recent-item-icon" size={16} strokeWidth={2} />
              </div>
              <span className="recent-item-name">{item.name}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
